<template>
  <div style="width: 100%; height: 100%">
    <DoubleLineEchart
      :legendData="legendData"
      :chartData="chartData"
    ></DoubleLineEchart>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "OpinionRealTime",
  controller: "UI",
  action: "OpinionRealTime",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      legendData: [],
      chartData: {
        data1: [],
        data2: [],
        xData: [],
      },
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      let that = this;
      let searchInfo = {
        BeginTime: new Date().format("yyyy-MM-dd 00:00"),
        EndTime: new Date().format("yyyy-MM-dd 23:59"),
      };
      new MyApis.OpinionApi()
        .GetTodayReport(searchInfo)
        .then((r) => {
          r = r.data.Data;

          that.drawChart(r);
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    drawChart(data) {
      if (data) {
        this.legendData = [];

        var linegooddata = data.ChartTrendGood.SeriesData1[0];
        var linebaddata = data.ChartTrendBad.SeriesData1[0];

        this.legendData.push(linegooddata.name);
        this.legendData.push(linebaddata.name);
        this.chartData.data1 = linegooddata.data;
        this.chartData.data2 = linebaddata.data;
        this.chartData.xData = data.ChartTrendGood.XData || [];
      }
    },
  },
};
</script>